import React from 'react'
import { axios } from 'core'
import { Button } from 'ui'
import { useAlertStore } from 'store'

export default function RestartBot() {
  const alert = useAlertStore()
  const [fetching, setFetching] = React.useState(false)

  async function handleRestart() {
    if (fetching) return
    setFetching(true)

    await axios
      .post('/bot/restart')
      .then(() =>
        alert.success({
          title: 'Бот перезапущен',
          buttons: [{ text: 'Ок', onClick: alert.clear }],
        })
      )
      .catch(({ response }) =>
        alert.error({
          title: response?.data?.message || 'Непредвиденная ошибка',
          buttons: [{ text: 'Ок', onClick: alert.clear }],
        })
      )

    setFetching(false)
  }

  return (
    <Button
      component="button"
      text={fetching ? 'Перезапуск...' : 'Перезапустить бота'}
      size="SMALL"
      theme="CANCEL"
      onClick={handleRestart}
    />
  )
}
